import { IDeleteAuditoriaUseCase } from "../../../presentation/useCases/delete/delete_auditoria_servicos_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

// DeleteAuditoriaUseCase

export class DeleteAuditoriaUseCase implements IDeleteAuditoriaUseCase {
  constructor(private readonly repository: IAuditorRepository) {}

  async deleteAuditoria(IdAuditoria: number): Promise<void> {
    
    await this.repository.deleteAuditoria(IdAuditoria);
  }
}
